import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumFileCertified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M13 19H6V4h7v4h4v6h1V7l-4-4H6c-.5 0-1 .5-1 1v15c0 .5.5 1 1 1h7v-1zm1-14.4L16.4 7H14V4.6z"
      style={{
        fill: "#676767",
      }}
    />
    <circle
      cx={17.5}
      cy={18.5}
      r={3.5}
      style={{
        fill: "#4bbc91",
      }}
    />
    <path
      d="M19.5 17c-.2-.1-.4-.1-.6.1L17.4 19l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumFileCertified);
export default Memo;
